import React from "react";
import { Navigate } from "react-router-dom";
import { PERMISSION } from "common/permission";

const Authmiddleware = (props) => {

  if (!localStorage.getItem("tokens")) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  const { route: { permission, action } } = props
  if (permission && action) {
    const isPagePermission = isPagePermissionExist(permission, action)
    if (!isPagePermission) {
      return (
        <Navigate to={{ pathname: "/forbidden-zone", state: { from: props.location } }} />
      );
    }
  }

  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

const isPagePermissionExist = (permission,action) =>{
  
  const permissionsStr= localStorage.getItem("permissions")
  try {
    const rolesPermission = JSON.parse(permissionsStr);
    const pagePermission = rolesPermission.find(p => p.permission_name == permission)
    return pagePermission &&  pagePermission[action] == PERMISSION.PERMISSION_STATUS.ALLOWED
  } catch (error) {
    return false
    
  }

}


export default Authmiddleware;
